import {useEffect, useState} from "react";
import {db} from "../db";
import CollectionImage from "../components/CollectionImage";
import DoubleRightIcon from "../images/icons/white-double-right.svg";
import DoubleLeftIcon from "../images/icons/white-double-left.svg";
import GreyDoubleRightIcon from "../images/icons/grey-double-right.svg";
import GreyDoubleLeftIcon from "../images/icons/grey-double-left.svg";
import { useCollectionContext, useCollectionContextDispatch } from "../context/CollectionContext";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { isUndefined } from "cropperjs";
import { useAccountContext } from "../context/AccountContext";
import { getCollectionHashes, getCollectionImage, updateAccount } from "../api-helper";
import cardPrivate from '../images/icons/image-card-icons/card-icon-private.svg';
import cardPublic from '../images/icons/image-card-icons/card-icon-public.svg';
import Logo from "../images/logo_light_grey.png";
import PromptSpin from "../images/prompts.lottie";
import { liveQuery } from "dexie";
import LazyLoad from "react-lazyload";

function Placeholder(props){
    if (props.Count >= 1) {
        const renderPlaceholders = () => {
            let NumberOfPlaceholders;
            let placeholder; 
            for (let i = 0; i < props.Count; i++) {
                placeholder =
                <div className={"group w-full rounded-xl overflow-hidden relative bg-gray-400 animate-pulse"}>
                    <img className={"w-full"} src="https://i.postimg.cc/632gRsSp/Final-logo-Black.png" alt='Help'/>
                </div>;
            };
            return [].concat(...Array(props.Count).fill(placeholder));
          };  
          return renderPlaceholders()
    }
}

export default function MyCollection(props) {
    const [loading, setLoadingImages] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [imageList, setImageList] = useState([]);
    const [tempImageList, setTempImageList] = useState([]);
    const [publicImage, setPublicImage] = useState(false);
    const [columnClass, setColumnClass] = useState("cols-4");
    const [redoPromptUid, setRedoPromptUid] = useState("");
    const [inputImage, setInputImage] = useState(null);
    const [zoomedImage, setZoomedImage] = useState(null);
    const [page, setPage] = useState(0);
    const [totalStoredImages, setTotalStoredImages] = useState(0);
    const [totalImages, setTotalImages] = useState(0);
    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState("All");
    const [showAll, setShowAll] = useState(false);
    const [saveImages, setSaveImages] = useState(false);
    const navigate = useNavigate();
    const collectionContextDispatch = useCollectionContextDispatch();
    const collectionContext = useCollectionContext();
    const accountContext = useAccountContext();
    const [animations, setAnimations] = useState(false);
    const [empty, setEmpty] = useState(false);
    const [sortMethod, setSortMethod] = useState("Newest");

    const getTotalStoredImages = async () => {
        setLoadingImages(true);
        await db.collectedImages.count().then((count) => {
            setTotalStoredImages(count);
            setTotalImages(count);
        })
        await refreshImages().then(() => {
            setLoadingImages(false);
        });
    };

    // useEffect(() => {
    //     const subscription = liveQuery(() => db.collectedImages.count())
    //         .subscribe(count => {
    //             console.log("My Collection Images: ", count);
    //             if (count > 1) {
    //                 refreshImages();
    //             }
    //         });
    
    //     // Cleanup function to unsubscribe when the component unmounts
    //     return () => subscription.unsubscribe();
    // }, [db]);

    const refreshImages = async () => {
        let collectionImages;

        if (category !== "All") {
            if (category === "Public" || category === "Private") {
                collectionImages = db.collectedImages.filter(image => image.public === (category === "Public"));
            } else if (category === "PublicTags"){
                collectionImages = db.collectedImages.filter(image => image.public && !isUndefined(image.tag) && image.tag.length > 0);
            } else if (category === "PrivateTags") {
                collectionImages = db.collectedImages.filter(image => !image.public && !isUndefined(image.tag) && image.tag.length > 0);
            } else if (category === "PublicNoTags") {
                collectionImages = db.collectedImages.filter(image => image.public && (isUndefined(image.tag) || image.tag.length === 0));
            } else if (category === "PrivateNoTags") {
                collectionImages = db.collectedImages.filter(image => !image.public && (isUndefined(image.tag) || image.tag.length === 0));
            } else {
                collectionImages = db.collectedImages.filter(image => !isUndefined(image.tag) && image.tag.toLowerCase().includes(category.toLowerCase()));
            }
        } else {
            collectionImages = db.collectedImages;
        }

        switch(sortMethod){
            case "Newest": break;
            case "Oldest": collectionImages = collectionImages.reverse(); break;
            case "Non-Tagged-Asc": collectionImages = collectionImages.filter(image => isUndefined(image.tag) || image.tag === ""); break;
            case "Non-Tagged-Desc": collectionImages = collectionImages.reverse().filter(image => isUndefined(image.tag) || image.tag === ""); break;
            case "SH-Images-Asc": collectionImages = collectionImages.filter(image => !isUndefined(image.model) && image.model.includes('SH')); break;
            case "SH-Images-Desc": collectionImages = collectionImages.reverse().filter(image => !isUndefined(image.model) && image.model.includes('SH')); break;
        }

        if (!showAll) {
            collectionImages = collectionImages.reverse().offset(page * 20).limit(20);
        } else {
            collectionImages = collectionImages.reverse();
        }

        collectionImages = await collectionImages.toArray();

        setTotalImages(collectionImages.length);
        setImageList(collectionImages);
        collectionImages = null;
    }

    useEffect(() => {
        db.settings.where("key").equals("enable_animations").first(setting => {
            setAnimations(setting.value)
        })
        setTotalImages(collectionContext.totalImages);
    }, [collectionContext.totalImages])

    /**
     * Clears the generated image collection
     * @returns {Promise<void>}
     */
        const doClearGenerated = async () => {
            Swal.fire({
                color: "#190A4E",
                title: "Clear all saved images, this cannot be undone?",
                icon: "info",
                confirmButtonText: 'Confirm',
                confirmButtonColor: "#FFB02E",
                showDenyButton: true,
                denyButtonText: "Cancel",
                denyButtonColor: "#190A4E",
            }).then((result) => {
                if (result.isConfirmed) {
                    db.collectedImages.clear().then(getTotalStoredImages);
                    saveCollection()
                }
            });
        }

    useEffect(() => {
        // if (accountContext.loggedIn) {
        //     setLoadingImages(true);
        // }
        if (sessionStorage.getItem('initialCollectionLoad') || sessionStorage.getItem('initialCollectionLoad') === "true") {
            setLoadingImages(true);
        }
        if (collectionContext.finishedLoading || sessionStorage.getItem('finishedCollectionLoad') == "true") {
            getTotalStoredImages().then(async() => {
                sessionStorage.setItem('finishedCollectionLoad', 'true');
                await db.collectedImages.count().then((count) => {
                    setTotalStoredImages(count);
                })
                console.log("Finished loading images from the server MC");
                // collectionContextDispatch({type: 'resetLoading'});
            })
        }
    }, [collectionContext.finishedLoading]);

    /*useEffect(() => {
        refreshImages();
    }, [page, showAll, category, sortMethod]);
    */

    useEffect(() => {
        refreshImages()
    }, [page, showAll, category, sortMethod]);

    const fetchTags = async () => {
        const tempSet = new Set();
        await db.collectedImages.each(record => {
            if (record.tag) {
              record.tag.split(",").forEach(tag => {
                if (tag) {
                  tempSet.add(tag.trim());
                }
              });
            } else {
              setEmpty(true);
            }
        });
          
        let uniqueArray = [];
        let lowercasedArray = [];
        
        Array.from(tempSet).forEach(value => {
            if (!lowercasedArray.includes(value.toLowerCase())) {
                uniqueArray.push(value);
                lowercasedArray.push(value.toLowerCase());
            }
        });

        lowercasedArray = null;
        
        setCategories(uniqueArray.sort((a, b) => a.localeCompare(b)));
        collectionContextDispatch({type: 'collectionTagging', tags: uniqueArray});
            
        
        // db.collectedImages.toArray((images) => {
        //     const tempSet = new Set();
        //     images.forEach(image => {
        //       if (image.tag) {
        //         image.tag.split(",").forEach(tag => {
        //           if (tag) {
        //             tempSet.add(tag.trim());
        //           }
        //         });
        //       } else {
        //         setEmpty(true);
        //       }
        //     });
          
        //     let uniqueArray = [];
        //     let lowercasedArray = [];

        //     Array.from(tempSet).forEach(value => {
        //         if (!lowercasedArray.includes(value.toLowerCase())) {
        //             uniqueArray.push(value);
        //             lowercasedArray.push(value.toLowerCase());
        //         }
        //     });

        //     lowercasedArray = null;
            
        //     setCategories(uniqueArray.sort((a, b) => a.localeCompare(b)));
        //     collectionContextDispatch({type: 'collectionTagging', tags: uniqueArray});
        //   });
    }

    useEffect(() =>{
        fetchTags();
    },[imageList])

    useEffect(() => {
        if (inputImage !== null) {
            collectionContextDispatch({type: 'collectionImage', payload: inputImage})
            navigate("/");
        }     
    }, [inputImage])

    const getNumColumns = () => {
        switch(columnClass) {
            case "cols-1":
                return "grid-cols-1 md:grid-cols-1 lg:grid-cols-1";
            case "cols-2":
                return "grid-cols-2 md:grid-cols-2 lg:grid-cols-2";
            case "cols-3":
                return "grid-cols-1 md:grid-cols-3 lg:grid-cols-3";
            default:
            case "cols-4":
                return "grid-cols-1 md:grid-cols-4 lg:grid-cols-4";
            case "cols-5":
                return "grid-cols-1 md:grid-cols-5 lg:grid-cols-5";
            case "cols-6":
                return "grid-cols-1 md:grid-cols-6 lg:grid-cols-6";
        }
    }

    const saveCollection = async () => {
        getTotalStoredImages();
        setSaveImages(false);
    }

    const setGeneratePrompt = (prompt) => {
        console.log(prompt);
        let generate;
        try {
            generate = JSON.parse(localStorage.getItem("Generate"))
        } catch (error) {
            console.error("Error fetching the generate value in Collection: ", error)
        }
        // let generate = JSON.parse(localStorage.getItem('Generate'));
        try {
            localStorage.setItem('Generate', JSON.stringify({
                prompt: prompt,
                enhancePrompt: generate.enhancePrompt,
                seed: generate.seed,
                negativeKeywords: generate.negativeKeywords,
                steps: generate.steps,
                guidance: generate.guidance,
                imageCount: generate.imageCount,
                imageWidth: generate.imageWidth,
                imageHeight: generate.imageHeight,
                selectedModel: generate.selectedModel,
                selectedScheduler: generate.selectedScheduler,
                tile: generate.tile,
                shuffle: generate.shuffle,
                upscale: generate.upscale,
            }));
        } catch (error) {
            console.error("Error saving to Generate value in Collection: ", error)
        }
        setTimeout(() => {
            navigate("/");
        }, 250);
    }

    const handleEscapeKey = (e) => {
        if (e.key === "Escape") {
            setZoomedImage(null)
        }
    }

    useEffect(() => {
        if (zoomedImage) {
            window.addEventListener('keydown', handleEscapeKey);
        }

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleEscapeKey);
        };
    }, [zoomedImage]);

    return (
        <div className={"px-4 pb-4 relative"}>
            <h2 className={"text-xl py-2 font-bold flex flex-row items-center"}>
                <span>My Collection</span>
                <hr className={"flex-grow border border-white/40 bg-white/40"} />
                <select className={"rounded-lg text-dark-blue border-0 p-2 me-1"} value={sortMethod} onChange={(e) => setSortMethod(e.target.value)}>
                    <option value="Newest" key={"sort_1"}>From Newest</option>
                    <option value="Oldest" key={"sort_2"}>From Oldest</option>
                    <option value={"Non-Tagged-Asc"} key={"sort_3"}>Non-Tagged - New to Old</option>
                    <option value={"Non-Tagged-Desc"} key={"sort_4"}>Non-Tagged - Old To New</option>
                    <option value={"SH-Images-Asc"} key={"sort_5"}>SH Images - New to Old</option>
                    <option value={"SH-Images-Desc"} key={"sort_6"}>SH Images - Old to New</option>
                </select>
                <select className={"rounded-lg text-dark-blue border-0 p-2 me-1"} value={category} onChange={(e) => setCategory(e.target.value)}>
                    <option value={"All"} key={"category_1"}>All</option>
                    <option value={"Public"} key={"category_2"}>Public</option>
                    <option value={"PublicTags"} key={"category_3"}>Public - Tagged</option>
                    <option value={"PublicNoTags"} key={"category_4"}>Public - No Tags</option>
                    <option value={"Private"} key={"category_5"}>Private</option>
                    <option value={"PrivateTags"} key={"category_6"}>Private - Tagged</option>
                    <option value={"PrivateNoTags"} key={"category_7"}>Private - No Tags</option>
                    {categories.map((category, i) => <option value={`${category}`} key={`category ${i+7}`}>{category.charAt(0).toUpperCase() + category.slice(1).toLowerCase()}</option>)}
                </select>
                <button className={"py-2 px-4 mx-1 border rounded bg-red-400 transition"} onClick={doClearGenerated}>Delete All</button>
                <div className={"flex flex-row justify-end items-center p-4"}>
                    {!showAll ?
                    <>
                        {page > 0 ?
                            <button className={"text-4xl p-2"} onClick={() => setPage(page - 1)}>
                                <img src={DoubleLeftIcon} alt="Previous Page" className='h-10'/>
                            </button> 
                            : 
                            <button className={"text-4xl p-2 text-gray-400"} >
                                <img src={GreyDoubleLeftIcon} alt="Previous Page" className='h-10'/>
                            </button>}
                        <div className={"text-xl p-2"} >{page + 1}</div>
                        {(page * 20 + 20) < totalStoredImages ?
                            <button className={"text-4xl p-2"} onClick={() => setPage(page + 1)}>
                                <img src={DoubleRightIcon} alt="Next Page" className='h-10'/>
                            </button> 
                            :  
                            <button className={"text-4xl p-2 text-gray-400"} >
                                <img src={GreyDoubleRightIcon} alt="Next Page" className='h-10'/>
                            </button>}
                    </>
                        : 
                    null}
                    <button className={"py-2 px-4 mx-1 border rounded hover:bg-dark-blue transition"} onClick={() => setShowAll(!showAll)}>Show {showAll ? "Pages" : "All"}</button>
                    <span className={"font-light mr-5 text-sm"}>Total Images: <span className={"font-bold"}>{totalImages}/{totalStoredImages}</span></span>
                    <select className={"rounded-lg text-dark-blue border-0 p-2"}
                            value={columnClass} onChange={(e) => setColumnClass(e.target.value)}>
                        <option value={"cols-2"}>2 Columns</option>
                        <option value={"cols-3"}>3 Columns</option>
                        <option value={"cols-4"}>4 Columns</option>
                        <option value={"cols-5"}>5 Columns</option>
                        <option value={"cols-6"}>6 Columns</option>
                    </select>
                </div>
            </h2>
                {loading ? 
                    <>
                        {animations ?
                            <div className="w-2/3 mx-auto">
                                <lottie-player
                                autoplay
                                loop
                                mode="normal"
                                src={PromptSpin}
                                ></lottie-player>
                            </div>
                        :
                            <img src={Logo} alt={"Promptus Logo"} className="w-2/3 mx-auto animate-pulse" />  
                        }
                    </>             
                :    
                <>
                    {accountContext.loggedIn ? 
                        <div className={`grid ${getNumColumns()} gap-4`}>
                        {imageList.map((image, i) => (
                        <LazyLoad key={`image_${i}_${image.id}`} height={2} offset={200} placeholder={<Placeholder Count={1}></Placeholder>}>
                            <CollectionImage
                                {...image}
                                key={`image_${image.id}`}
                                refreshImages={getTotalStoredImages}
                                setSaveImages={setSaveImages}
                                setZoomedImage={(image) => setZoomedImage(image)}
                                setUid={setGeneratePrompt}
                                setImage={(image) => setInputImage({image})}
                                tagArray={collectionContext.collectionTags}
                                dbTable={db.collectedImages}
                                refreshTags={fetchTags}
                                isMyCollection={true}
                                inCollection={true}
                            />
                        </LazyLoad>    
                        ))}
                        </div>
                    :    
                        <h1>Please login before viewing collection</h1>
                    }
                </>
            }
            
            {zoomedImage ?
                <div className={"absolute top-64 bg-dark-blue/30 backdrop-blur-sm w-full flex flex-col place-items-center justify-center"} onClick={() => setZoomedImage(null)} onKeyUp={(e) => handleEscapeKey(e)}>
                    <div className={"relative"}>
                        <button className={"absolute top-0 right-0 px-5 py-2 bg-dark-blue/40 rounded-lg hover:bg-dark-blue transition"} type={"button"}>Close</button>
                        <img className={"w-auto max-w-screen-md rounded-lg"} src={`data:image/webp;base64,${ zoomedImage.image }`} alt={`Generated image: ${ zoomedImage.seed }`} />
                    </div>
                </div>
                : null}
        </div>
    );
}
